import { map } from 'lodash';
import { connect } from 'react-redux';

import CollectionFilterSelector from 'components/CollectionFilterSelector';
import * as actions from 'state/actions';
import Catalog from 'state/selectors/catalog';
import CollectionPage from 'state/selectors/collection-page';
import Filters, { APPEARANCES } from 'utils/Filters';

const mapStateToProps = (state, { filterIdentifier, ...ownProps }) => {
  const filterConfiguration = Filters.getFilterConfiguration({ filterIdentifier });
  const parentCollectionHandle = CollectionPage.getCollectionHandle(state);
  const isLoading = Catalog.isParentCollectionLoading(state, parentCollectionHandle);

  if (!filterConfiguration && !isLoading) {
    throw new Error(`Could not find filter configuration for "${filterIdentifier}"`);
  }

  // Bail early when in loading state
  if (isLoading) {
    return {
      filterIdentifier,
      isExpanded: false,
      isLoading,
      options: [],
      appearance: APPEARANCES.DEFAULT,
      ...ownProps,
    };
  }

  const collectionCacheKey = Catalog.getParentCollectionCacheKey(state, parentCollectionHandle);
  const cacheKey = `${collectionCacheKey}__filterIdentifier:${filterIdentifier}`;
  const items = Catalog.getAvailableParentCollectionColorways(state, parentCollectionHandle);
  const possibleFilterOptions = Filters.enumeratePossibleFilterOptions({
    items,
    filterConfiguration,
    cacheKey,
  });

  const options = map(possibleFilterOptions, ({ option, label, grouping }) => ({
    option,
    label,
    grouping,
    value: CollectionPage.getFilterOptionValue(state, { filterIdentifier, option }),
  }));
  const isExpanded = CollectionPage.isFilterExpanded(state, { filterIdentifier });
  const { appearance } = filterConfiguration;

  return {
    filterIdentifier,
    isExpanded,
    isLoading,
    options,
    appearance,
    ...ownProps,
  };
};

const mapDispatchToProps = dispatch => ({
  setCollectionPageFilter: ({ option, value, filterIdentifier }) =>
    dispatch(actions.setCollectionPageFilter({ option, value, filterIdentifier })),
  expandCollectionPageFilter: ({ filterIdentifier }) =>
    dispatch(actions.expandCollectionPageFilter({ filterIdentifier })),
});

const mergeProps = (stateProps, dispatchProps) => ({
  onFilterOptionSelect: ({ option, value }) =>
    dispatchProps.setCollectionPageFilter({
      option,
      value,
      filterIdentifier: stateProps.filterIdentifier,
    }),
  onExpand: () =>
    dispatchProps.expandCollectionPageFilter({ filterIdentifier: stateProps.filterIdentifier }),
  ...stateProps,
});

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(CollectionFilterSelector);
